import { render, staticRenderFns } from "./FormPeopleItem.vue?vue&type=template&id=6994783f&"
import script from "./FormPeopleItem.vue?vue&type=script&lang=js&"
export * from "./FormPeopleItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports